import { useState } from "react";
import { useNavigate, useParams, useRevalidator, useRouteLoaderData } from "react-router-dom";
import LocatorEmergencyForm from "src/components/outside/locator/locatorEmergencyForm";
import { LocatorWeekData, Division } from "./actions_loaders";

type LoaderData = {
    week: string;
    locator: {
        id: string;
        email: string;
        userName: string;
        lanId?: string;
    };
    weekData: LocatorWeekData;
    divisions: Division[];
};

export default function AllLocatorEmergencyEdit() {
    const { week, locator, weekData, divisions } = useRouteLoaderData("AllLocatorDetail") as LoaderData;
    const { dayIndex } = useParams();
    const navigate = useNavigate();
    const revalidator = useRevalidator();
    const [localWeekData, setLocalWeekData] = useState(weekData);
    const index = Number(dayIndex ?? 0);

    return (
        <LocatorEmergencyForm
            closeIt = {() => {
                revalidator.revalidate();
                navigate(`/OutsideStatus/${week}/${locator.id}`);
            }}
            defaultData = {localWeekData}
            week = {week}
            dayIndex = {index}
            admin = {true}
            userId = {locator.id}
            email = {locator.email}
            userName = {locator.userName}
            lanId = {locator.lanId}
            divisions = {divisions}
            onWeekFormChange = {setLocalWeekData}
        />
    );
}
